import React from "react";
import { connect } from "react-redux";
import { orderStateReport } from '.././../../constants/analytics';
import { cleanReports } from '../../../actions/reports';
import { TableHeader } from '../../orders/OrdersTable';
import Row from '../../orders/OrderRow';
import * as fetchingState from '../../../constants/fetchingState';
import { Panel } from "react-bootstrap";
import Total from './Total';

let OrdersReport = class extends React.Component {
    componentWillUnmount() {
        this.props.cleanReports();
    }

    render() {
        const { report, fetching } = this.props;
        if (fetching === fetchingState.FETCHING)
            return <span>Загрузка...</span>;


        return <div>
            <Total {...report} />
            <Panel>
                <Panel.Heading>Заказы</Panel.Heading>
                <Panel.Body>
                    <TableHeader orders={report.Orders}>
                        {report.Orders && report.Orders.map(o => <Row order={o} isReport={true} key={o.Id} />)}
                    </TableHeader>
                </Panel.Body>
            </Panel>
        </div>


    }
};

OrdersReport = connect(state => ({
    report: state.application.get('reports')[orderStateReport].data,
    fetching: state.application.get('reports')[orderStateReport].fetching
}), { cleanReports })(OrdersReport);

export default OrdersReport;


// WEBPACK FOOTER //
// ./src/components/analytics/orders/OrdersReport.jsx